import { createActionTypes } from "@helpers/redux-helpers";

export const setAuthorsActionType = "authors/set";
export const blockAuthorActionType = "authors/block";
export const unblockAuthorActionType = "authors/unblock";
export const setAuthorDeletedActionType = "authors/delete";

export const updateOnlineStatusActionType = "authors/onlineStatus";

export const blockedByUserActionTypes = createActionTypes("authors/blocked");
export const unblockedByUserActionTypes =
  createActionTypes("authors/unblocked");
